import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // useHistoryからuseNavigateに変更  
import styled, { keyframes } from 'styled-components';
import { farms } from '../components/List_farms';
import DataTransferAnimation from '../components/Animation_copilot';
import GreenhouseImage from '../components/Image_Greenhouse'; // 新しいコンポーネントをインポート  
// import GreenhouseRoboImage from '../components/Image_Robo'; // 新しいコンポーネントをインポート  
import HarvestChart from '../components/Chart_Harvest';  //暫定追加  
import YieldPerformance from '../components/Yield_performance';  // 追加  
import ChartMarketAVGComponent from '../components/Chart_Market_avg';
// import ChartComponent from '../components/Chart_Sensing';  // 追加  
import DataCardsSensing from '../components/DataCard_Sensing';  // 新しいコンポーネントをインポート  
import RobotStatus from '../components/RobotStatus'; // 新しいコンポーネントをインポート  
import robots from '../components/List_robots';
import { fetchForecastWeatherData, fetchHouseSituation, fetchAIRecommendation, fetchMarketAvgData } from './api'; // api.js から関数をインポート  

const RecWrapper = styled.div`  
  display: flex;  
  flex-direction: column;  
  width: 100%;  
  // max-width: 1200px;  /* 最大幅を設定 */  
  margin: 0 auto;     /* 中央揃え */  
  gap: 20px;  
  margin-bottom: 20px;  
  
  @media (min-width: 768px) {  
    flex-direction: row;  
    justify-content: space-between;  
    align-items: stretch;  
    gap: 20px;  
  }  
`;

const GreenhouseImageStyled = styled.div`  
  flex-basis: 50%; /* 幅の50%を使用 */  
  max-width: 500px;  /* 最大幅を600pxに制限 */  
  @media (min-width: 768px) {  
    flex-basis: 50%;  /* 幅の50%に固定 */  
  }  
`;

// 新しくラップするスタイルコンポーネントを追加  
// const CenteredImageWrapper = styled.div`  
//   // display: flex;  
//   justify-content: center;  
//   align-items: center;  
//   width: 100%;  
//   max-width: 400px; /* 必要に応じて調整 */  
//   margin: 0 auto; /* 中央揃え */  
//   // margin-bottom: 20px;  
// `;

const RecContainer = styled.div`  
  background-color: #ffffff;  
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);  
  border-radius: 15px;  
  padding: 15px;  
  flex-grow: 1;  /* 横幅を柔軟に調整 */  
  max-width: none; /* 最大幅を解除して、横幅いっぱいに拡張 */  
  
  @media (max-width: 767px) {  /* スマホの場合の設定 */  
    height: 170px;  /* 固定の高さを設定 */  
    overflow-y: auto;  /* 縦方向のスクロールを有効にする */  
  }  
  
  @media (min-width: 768px) {  
    flex-basis: calc(100% - 360px); /* 画面幅から画像の幅を引いた値 */  
    overflow-y: auto;  /* 縦方向のスクロールを有効にする */  
    height: 250px;  /* 例えば200pxに設定 */  
    flex-grow: 1;  
  }  
`;

const Container = styled.div`  
  padding: 20px;  
  background: #fafafa;  /* 背景色を変更 */  
  min-height: 100vh;  
  font-family: Arial, sans-serif; /* フォントを一致させる */  
`;

const ContentWrapper = styled.div`  
  display: flex;  
  flex-direction: column;  
  width: 100%;  
  margin-bottom: 20px;  
  gap: 20px; /* 追加: 20px の隙間を作成 */  
  
  @media (min-width: 768px) {  
    flex-direction: row;  
    justify-content: space-between;  
    align-items: stretch;  
    gap: 20px; /* 追加: 20px の隙間を作成 */  
  }  
`;

const zoomInOut = keyframes`  
  0% { transform: scale(1); }  
  50% { transform: scale(1.2); }  
  100% { transform: scale(1); }  
`;

const LoadingContainer = styled.div`  
  display: flex;  
  flex-direction: column;  
  justify-content: center;  
  align-items: center;  
  height: 100vh;  
  background: #fafafa;  /* 背景色を一致させる */  
`;

const LoadingText = styled.div`  
  font-size: 2rem;  
  color: #333333;  
  font-weight: bold;  
  margin-bottom: 20px;  
`;

const LoadingImage = styled.img`  
  // width: 100px;  
  height: 100px;  
  animation: ${zoomInOut} 2s infinite;  
  border-radius: 10px;  
`;

const ButtonContainer = styled.div`  
  display: flex;  
  justify-content: space-around;  
  // margin-top: 30px; 
  margin-bottom: 20px; 

`;

const AiButton = styled.button`  
  margin-bottom: 20px;  
  width: 100%;  
  background-color: #4CAF50; /* ボタンの背景色を変更 */  
  color: white; /* テキストの色を白に変更 */  
  border: none;  
  padding: 10px 20px;  
  font-size: 1.5em; /* フォントサイズを大きく */  
  border-radius: 15px;  
  font-weight: bold; 
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);  
  cursor: pointer; /* カーソルをポインターに変更 */  
  transition: background-color 0.3s, transform 0.3s;  
    
  &:hover {  
    background-color: #45a049; /* ホバー時の背景色 */  
    transform: scale(1.05); /* ホバー時に少し拡大 */  
  }  
`;  
  
const Button = styled.button`  
  width: 100%;
  background-color: #4CAF50; /* ボタンの背景色を変更 */  
  color: white; /* テキストの色を白に変更 */  
  border: none;  
  padding: 10px 20px;  
  font-size: 1em;  
  font-weight: bold; 
  border-radius: 15px;  
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);  
  cursor: pointer; /* カーソルをポインターに変更 */  
  transition: background-color 0.3s, transform 0.3s;  
    
  &:hover {  
    background-color: #45a049; /* ホバー時の背景色 */  
    transform: scale(1.05); /* ホバー時に少し拡大 */  
  }  
`;  

const FarmDetail = () => {
  const { greenhouse } = useParams();
  const [farmData, setFarmData] = useState(null);
  const [weatherData, setWeatherData] = useState(null);
  const [error, setError] = useState(null);
  const [recommendation, setRecommendation] = useState('');
  const farm = farms.find(farm => farm.greenhouse === greenhouse);
  // greenhouseに一致するロボットの名前を抽出  
  const matchingRobots = robots.filter(robot => robot.greenhouse === greenhouse);
  const [avgData, setAvgData] = useState([]); // 新しいAPIのデータを格納するためのステート  
  // const [loading, setLoading] = useState(true);  
  const navigate = useNavigate(); // useHistoryをuseNavigateに変更  

  const getWeatherState = (iconCode) => {
    if ([1, 2, 3, 4, 5, 30, 33, 34, 35, 36, 37].includes(iconCode)) {
      return "sunny";
    } else if ([6, 7, 8, 20, 23, 38, 39, 40, 42, 43, 44].includes(iconCode)) {
      return "cloudy";
    } else if ([12, 13, 14, 18, 19, 20, 21, 29, 39, 40].includes(iconCode)) {
      return "rain";
    } else if ([15, 16, 17, 41, 42].includes(iconCode)) {
      return "thunderstorm";
    } else if ([22, 23, 25, 29, 43, 44].includes(iconCode)) {
      return "snow";
    } else if ([11].includes(iconCode)) {
      return "fog";
    } else if ([32].includes(iconCode)) {
      return "windy";
    } else if ([24, 25, 26, 31].includes(iconCode)) {
      return "ice";
    } else {
      return "unknown";
    }
  };

  useEffect(() => {  
    const controller = new AbortController();  
    const fetchData = async () => {  
      try {  
        const data = await fetchHouseSituation(greenhouse);  
        setFarmData(data);  
        try {  
          const content = await fetchAIRecommendation(data, farm.jpkinds, farm.location);  
          setRecommendation(content);  
        } catch (apiError) {  
          setError(apiError);  
        }  
      } catch (error) {  
        setError(error);  
      }  
    };  
    fetchData();  
    return () => controller.abort();  
  }, [greenhouse, farm.jpkinds, farm.location]);  

  useEffect(() => {  
    const controller = new AbortController();  
    const fetchWeatherDataAsync = async () => {  
      try {  
        const data = await fetchForecastWeatherData(farm.location, farm.lat, farm.lon);  
        setWeatherData(data);  
      } catch (error) {  
        setError(error);  
      }  
    };  
    fetchWeatherDataAsync();  
    return () => controller.abort();  
  }, [farm.location, farm.lat, farm.lon]);  

  // 新しいAPIのデータを取得するためのuseEffect  
  useEffect(() => {  
    const controller = new AbortController();  
    const fetchAvgDataAsync = async () => {  
      try {  
        const result = await fetchMarketAvgData(farm.jpkinds);  
        setAvgData(result);  
      } catch (error) {  
        setError(error.message);  
      }  
    };  
    fetchAvgDataAsync();  
    return () => controller.abort();  
  }, [farm.jpkinds]);  

  // if (error) {
  //   return (
  //     <LoadingContainer>
  //       <LoadingText>建設中</LoadingText>
  //       <LoadingImage src="/greenhouse.png" alt="Loading" />
  //       <a href="/" style={{ display: 'block', margin: '10px 0', color: '#333333', fontWeight: 'bold', textDecoration: 'none' }}>TOP画面に戻る</a>
  //     </LoadingContainer>
  //   );
  // }

  if (!farmData && !error) {  
    return (  
      <LoadingContainer>  
        {/* <Header /> */}  
        <LoadingText>データ取得中</LoadingText>
        <LoadingImage src="/greenhouse.png" alt="Loading" />  
      </LoadingContainer>  
    );  
  }    

  const weatherState = weatherData && weatherData.forecasts && weatherData.forecasts.length > 0
    ? getWeatherState(weatherData.forecasts[0].day.iconCode)
    : "unknown";

  const navigateToChartPage = () => {
    navigate('/chart', { state: { farmData, greenhouseName: farm ? farm.name : greenhouse } });
  };

  const navigateToAiPage = () => {  
    navigate('/ai', { state: { farmname:farm.name, greenhouse: farm.greenhouse, itemName: farm.jpkinds } });  
};  

  return (
    <Container>
      <h2 style={{ color: '#333333' }}>{farm ? farm.name : greenhouse}</h2>
      <RecWrapper>
        <GreenhouseImageStyled>
          <GreenhouseImage weather={weatherState} isLightChange={!error} />  
        </GreenhouseImageStyled>
        {!error && <RecContainer>
          <h2>AGRIST Copilot</h2>
          {recommendation ? (
            <p>{recommendation}</p>
          ) : (
            <DataTransferAnimation />
          )}
        </RecContainer>}
      </RecWrapper>
      <YieldPerformance greenhouse={greenhouse} areaInR={farm.size} regionalavg={farm.regionalavg} size={farm.size}/>
      <AiButton onClick={navigateToAiPage}>AGRIST Ai</AiButton> {/* 追加 */} 
      <ContentWrapper>
        <HarvestChart greenhouse={greenhouse} />
        <ChartMarketAVGComponent data={avgData} />
      </ContentWrapper>
      
      {/* <h2>全国の平均{farm.jpkinds}価格チャート</h2> */}
      {/* <ChartMarketComponent data={data} selectedCity={'東京'} showPrices={true} chartType="national" /> */}

      {!error && <DataCardsSensing farmData={farmData} />}  

      {/* <ContentWrapper>  
        <ChartComponent farmData={farmData} />  
      </ContentWrapper>   */}
      <ButtonContainer>
        {!error && <Button onClick={navigateToChartPage}>環境データ</Button>}
      </ButtonContainer>
      {/* <CenteredImageWrapper>
        <GreenhouseRoboImage isLightChange={true} />
      </CenteredImageWrapper> */}
      {/* <ContentWrapper>  
        <HarvestChart greenhouse={greenhouse} />  
        <ChartComponent farmData={farmData} />  
      </ContentWrapper> */}
      <RobotStatus robots={matchingRobots} />
      <ButtonContainer>
        <Button>{"AGRIST Cloud Farm\nAI統合環境制御\n- 近日公開 -"}</Button>
        <Button>{"AGRIST Farming Planner\nAI営農管理\n- 近日公開 -"}</Button>
      </ButtonContainer>
      <a href="/" style={{ display: 'block', margin: '10px auto', color: '#333333', fontWeight: 'bold', textDecoration: 'none', textAlign: 'center' }}>TOP画面に戻る</a>
    </Container>
  );
};

export default FarmDetail;  
